export default __webpack_public_path__ + "static/media/heartkey.a4b4102d.mp4";